import { Trans } from '@lingui/react'
import styles from './CatastrophicErrorDisplay.module.scss'

export default class CatastrophicErrorDisplay extends React.PureComponent {
  static propTypes = {
    title: PropTypes.node,
    description: PropTypes.node,
    resolution: PropTypes.node,
    errors: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        message: PropTypes.string,
        date: PropTypes.instanceOf(Date),
      }),
    ])),
  }

  static defaultProps = {
    title: 'Something went wrong',
    resolution: <Trans>You can try reloading this page. If the problem persists, contact support.</Trans>,
  }

  render() {
    const {
      title,
      description,
      resolution,
      errors,
    } = this.props
    return (
      <div className={cx(styles.root, 'errors text-center')}>
        <h1>{title}</h1>
        {description && (<p>{description}</p>)}
        {(errors && errors.length) && (
          <div className={styles.errorContainer}>
            <blockquote className="color-error">
              {errors.length === 1 ? errors[0].message : (
                <ul>
                  {errors.map(({ message }) => (
                    <li key={message}>{message}</li>
                  ))}
                </ul>
              )}
            </blockquote>
          </div>
        )}
        {resolution && (<p>{resolution}</p>)}
      </div>
    )
  }
}
